/* Reine Datumsrechnung für den Kalender — ohne React, damit sie sich testen lässt. */

const schluessel = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/* Die 42 Zellen eines Monatsrasters (Montag zuerst). Jahr und Monat der Nachbarmonate werden über Date
   normalisiert: Dezember + 1 ist Januar des Folgejahres, nicht „Monat 13“. */
export function monatsTage(year, month) {
  const firstDay = new Date(year, month, 1).getDay();
  const startOffset = firstDay === 0 ? 6 : firstDay - 1;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrev = new Date(year, month, 0).getDate();
  const vor = new Date(year, month - 1, 1);
  const nach = new Date(year, month + 1, 1);
  const days = [];
  for (let i = startOffset - 1; i >= 0; i--) {
    days.push({ day: daysInPrev - i, month: vor.getMonth(), year: vor.getFullYear(), isCurrentMonth: false });
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({ day: i, month, year, isCurrentMonth: true });
  }
  const remaining = 42 - days.length;
  for (let i = 1; i <= remaining; i++) {
    days.push({ day: i, month: nach.getMonth(), year: nach.getFullYear(), isCurrentMonth: false });
  }
  return days;
}

/* Der Bereich, den die Kalenderseite lädt und anzeigt: Vormonat bis Ende des Folgemonats, als "YYYY-MM-DD". */
export function bereichUm(year, month) {
  return { von: schluessel(new Date(year, month - 1, 1)), bis: schluessel(new Date(year, month + 2, 0)) };
}

/* Ein Termin kann über mehrere Tage gehen: alle Tage von tag_von bis tag_bis als "YYYY-MM-DD".
   Gezählt wird nur innerhalb des angezeigten Bereichs — sonst verschwände eine lange Abwesenheit
   (Auszeit über Monate) nach den ersten Wochen aus dem Kalender und der Tag sähe frei aus. */
export function tageVonBis(von, bis, bereichVon, bereichBis) {
  const tage = [];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(von || '')) return tage;
  let ende = bis && bis >= von ? bis : von;
  let start = von;
  if (bereichVon && start < bereichVon) start = bereichVon;
  if (bereichBis && ende > bereichBis) ende = bereichBis;
  if (ende < start) return tage;
  const [j, m, t] = start.split('-').map(Number);
  const d = new Date(j, m - 1, t);
  for (let i = 0; i < 400; i++) {
    const key = schluessel(d);
    tage.push(key);
    if (key >= ende) break;
    d.setDate(d.getDate() + 1);
  }
  return tage;
}

/* Was an EINEM Tag von einem Termin gilt. Ein Seminar von Freitag 14 Uhr bis Sonntag 12 Uhr belegt den Samstag
   ganz — „14:00–12:00 Uhr“ an jedem der drei Tage wäre irreführend. -> { text, sortierung } */
export function tagesAnteil(termin, tag) {
  if (termin.ganztags) return { text: 'ganztägig', sortierung: '' };
  const mehrtaegig = termin.tag_bis > termin.tag_von;
  if (!mehrtaegig) return { text: `${termin.von}–${termin.bis} Uhr`, sortierung: termin.von || '' };
  if (tag === termin.tag_von) return { text: `ab ${termin.von} Uhr`, sortierung: termin.von || '' };
  if (tag === termin.tag_bis) return { text: `bis ${termin.bis} Uhr`, sortierung: '00:00' };
  return { text: 'ganztägig', sortierung: '' };
}
